import { featureFlagsSelectors } from '../selectors/featureFlagsSelectors';
import { useAppSelector } from './useThunkDispatch';
import { useIsBetaTester } from './useUserProfile';

export const useIsEcommerceEcouponsEnabled = () => {
    const isEnabledGlobally = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(state, 'EnableEcommerceEcoupons'),
    );
    const isEnabledForBetaTesters = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(
            state,
            'EnableEcommerceEcouponsForBetaTesters',
        ),
    );
    const isBetaTester = useIsBetaTester();

    return isEnabledGlobally || (!!isBetaTester && isEnabledForBetaTesters);
};

export const useIsMiniCartBonusNotificationEnabled = () => {
    const isEnabledGlobally = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(state, 'EnableMinicartBonusNotification'),
    );
    const isEnabledForBetaTesters = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(
            state,
            'EnableMinicartBonusNotificationForBetaTesters',
        ),
    );
    const isBetaTester = useIsBetaTester();

    return isEnabledGlobally || (!!isBetaTester && isEnabledForBetaTesters);
};

export const useIsEcommerceBonusTriggerEnabled = () => {
    const isEnabledGlobally = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(state, 'EnableEcommerceBonusTrigger'),
    );
    const isEnabledForBetaTesters = useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(
            state,
            'EnableEcommerceBonusTriggerForBetaTesters',
        ),
    );
    const isBetaTester = useIsBetaTester();

    return isEnabledGlobally || (!!isBetaTester && isEnabledForBetaTesters);
};
export const useIsOldPointshopItemsDisabled = () =>
    useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(state, 'DisableSearchOldPointshopItems'),
    );
